module.exports = __webpack_public_path__ + "img/utility_logo_white.e9999ad6.png";